import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface LivenessResponse {
  status: string;
  message: string;
  data: string;
}

@Injectable({
  providedIn: 'root'
})
export class PrivyLivenessService {

  private livenessUrl = environment.baseBackendUrl + '/external/privy';
  private checkVerifyUrl = environment.baseBackendUrl + '/external/privy/registration-status';
 
  constructor(private http: HttpClient) {}

  getPrivyAgent(request) {
    const token = sessionStorage.getItem('token');
    if (!token) { throw new Error('Authorization token not found'); }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    return this.http.post(this.livenessUrl, request, httpOptions);
  }

  getLivenessUrl(): Observable<LivenessResponse> {
    const token = sessionStorage.getItem('token');
    if (!token) { throw new Error('Authorization token not found'); }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    });

    return this.http.get<LivenessResponse>(this.livenessUrl + '/liveness', { headers });
  }

  verifyDukcapil(encryptedReq: { data: string }): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) { throw new Error('Authorization token not found'); }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    });

    return this.http.post<any>(this.livenessUrl + '/registration', encryptedReq, { headers }).pipe(catchError(this.handleError2));
  }

    checkStatusDukcapil(request) {
      const token = sessionStorage.getItem('token');
      if (!token) { throw new Error('Authorization token not found'); }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        })
      };
      return this.http.post(this.checkVerifyUrl, request, httpOptions);
    }

    private handleError2(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else if (error.status === 401) {
        // this.router.navigate(['login']);
      }
      else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, body was:`, error.error);
              return throwError(error.error);
      }
      // return an observable with a user-facing error message
      return throwError(
        'Something bad happened; please try again later.');
  }
}
